var textFragmentsToIgnore = ['Log In'];
var invalidToCapitalize = [
    'a',
    'an',
    'and',
    'as',
    'at',
    'but',
    'by',
    'for',
    'in',
    'nor',
    'of',
    'on',
    'or',
    'the',
    'to'
];
var capitalizeString = function (stringValue) {
    var childrenAsText = stringValue;
    var matchIgnoreLogic = childrenAsText.match(/\[(.*?)\]/g);
    var childrenToMatch = childrenAsText;
    if (matchIgnoreLogic) {
        childrenToMatch = childrenAsText.replace(/\[(.*?)\]/g, ''); // The text between [] is removed to ignore the capitalization logic.
    }
    if (textFragmentsToIgnore) {
        textFragmentsToIgnore.forEach(function (fragment) {
            childrenToMatch = childrenToMatch.replace(fragment, '');
        });
    }
    var childrenCapitalized = childrenToMatch.toLowerCase().replace(/\s+/g, ' '); // Applied lowercase to the text to be capitalized and removed double whitespace.
    var wordsExtracted = childrenCapitalized.split(' ');
    if ((wordsExtracted === null || wordsExtracted === void 0 ? void 0 : wordsExtracted.length) > 1) {
        wordsExtracted.forEach(function (word) {
            if (invalidToCapitalize.includes(word)) {
                return;
            }
            if (word.length === 0) {
                return;
            }
            var capitalized = word.replace(word[0], word[0].toUpperCase());
            childrenCapitalized = childrenCapitalized.replace(new RegExp("^".concat(word, "|( )+").concat(word), 'g'), "$1".concat(capitalized));
        });
    }
    if (matchIgnoreLogic) {
        matchIgnoreLogic.forEach(function (textFragment) {
            var firstIndex = childrenAsText.indexOf(textFragment);
            childrenCapitalized = "".concat(childrenCapitalized.slice(0, firstIndex) + textFragment, " ").concat(childrenCapitalized.slice(firstIndex));
        });
    }
    textFragmentsToIgnore.forEach(function (textFragment) {
        var firstIndex = childrenAsText.indexOf(textFragment);
        if (firstIndex >= 0) {
            childrenCapitalized = "".concat((childrenCapitalized.slice(0, firstIndex) + textFragment).trim(), " ").concat(childrenCapitalized.slice(firstIndex).trim());
        }
    });
    return (childrenCapitalized.charAt(0).toUpperCase() + childrenCapitalized.slice(1))
        .replace(/[[\]]+/g, '')
        .trim();
};
export default capitalizeString;
